export default "/kiban/_next/static/images/longHole_metal-dfa73af64fd32ca771b2c0a3ea2f6400.png";